/* RESPONSIBLE TEAM: team-proactive-support */
import { inject as service } from '@ember/service';
import ReportBase from 'embercom/routes/apps/app/reports/base/report';

export default ReportBase.extend({
  customReportsService: service(),

  beforeModel() {
    this.customReportsService.routeToOverviewPage();
  },
});
